var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"image-button",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{attrs:{"src":_vm.src,"title":_vm.title,"alt":_vm.alt || _vm.title}})])}
var staticRenderFns = []

export { render, staticRenderFns }